var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card",attrs:{"shadow":"hover"}},[_c('el-collapse',[_c('el-collapse-item',[_c('template',{slot:"title"},[_vm._t("cardHeader")],2),_vm._t("cardContent"),_c('el-footer',[_vm._t("cardFooter")],2)],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }